import createReactClass from 'create-react-class';
// -*- mode: jsx;-*-
/* eslint-disable react/prop-types */

import PureRenderMixin from '../common/external-adapters/pureRenderMixinAdapter.js';
import Teacher from './teacher.js';
import { teacherSearchOnly } from '../common/searchRequestUtils.js';
import { getURLParam } from '../adapters/dupes/queryParams.js';
import { addCommas } from '../utils/numberUtils.ts';

const TeacherList = createReactClass({
    mixins: [PureRenderMixin],

    showMore: function (event) {
        this.props.callbacks.applyFilters({ teachersOnly: true });
        event.preventDefault();
    },

    render: function () {
        const props = this.props;
        const teachers = props.teachers;
        const teacherElems = teachers.map((teacher) =>
            <Teacher searchURL={props.searchURL} callbacks={props.callbacks}
                favoriteTeacherIds={props.favorites && props.favorites.teacherIds}
                {...teacher} key={teacher.teacherId}/>,
        );

        const count = teachers[0].totalResults;
        let moreResults;
        let refineText;
        if (count > teachers.length && !teacherSearchOnly(props.searchURL)) {
            moreResults = (
                <a href="#" className="more-results" onClick={this.showMore}>View all {addCommas(count)} matching teachers</a>
            );
        }
        if(count >= 15) {
            refineText = (
                <div className="refine-search-tip">


                            <span>If you can't find who you're looking for, try adding the teacher's school name in your search</span>


                </div>
            );
        }

        return (

            <div>

                <h3>{addCommas(count)} {count > 1 ? 'teachers' : 'teacher'} found named &ldquo;{getURLParam(props.searchURL, 'keywords')}&rdquo;</h3>

                {refineText}

                <div className="teacher-search-results">

                    {teacherElems}
                    {moreResults}

                </div>

            </div>
        );
    },
});

export default TeacherList;
